var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgTop = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 84 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 84,
    height: 84
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 84,
    height: 84,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.46 16 42 21.029 49.54 16l8.225 2.058a6.486 6.486 0 0 1 4.542 4.134l6.471 18.344a3.894 3.894 0 0 1-.243 3.14l-8.379 15.569v4.863A3.892 3.892 0 0 1 56.266 68H27.735a3.892 3.892 0 0 1-3.891-3.892v-4.864l-8.379-15.568a3.894 3.894 0 0 1-.243-3.14l6.47-18.344a6.486 6.486 0 0 1 4.543-4.134L34.46 16Zm-8.022 42.59V31.67a1.297 1.297 0 1 0-2.594 0v22.101l-6.095-11.325a1.298 1.298 0 0 1-.081-1.047l6.47-18.343a3.891 3.891 0 0 1 2.726-2.481l7.113-1.78L42 24.148l8.023-5.351 7.113 1.779a3.891 3.891 0 0 1 2.725 2.48L66.332 41.4c.122.345.092.725-.08 1.047l-6.096 11.326V31.67a1.297 1.297 0 1 0-2.594 0v32.438c0 .716-.58 1.297-1.296 1.297H27.735a1.297 1.297 0 0 1-1.297-1.297V58.59Z",
    fill: "currentColor"
  }))));
};
export { SvgTop as ReactComponent };